/* tslint:disable */
/* eslint-disable */
/* @relayHash 3fa1cea298c68bd146236a2efb689269 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabContainerPaginationQueryVariables = {
    count: number;
    cursor?: unknown | null;
    orderBy: COMMENT_SORT;
    storyID?: string | null;
    flattenReplies: boolean;
    refreshStream?: boolean | null;
};
export type UnansweredCommentsTabContainerPaginationQueryResponse = {
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_story">;
    } | null;
};
export type UnansweredCommentsTabContainerPaginationQuery = {
    readonly response: UnansweredCommentsTabContainerPaginationQueryResponse;
    readonly variables: UnansweredCommentsTabContainerPaginationQueryVariables;
};



/*
query UnansweredCommentsTabContainerPaginationQuery(
  $count: Int!
  $cursor: Cursor
  $orderBy: COMMENT_SORT!
  $storyID: ID
  $flattenReplies: Boolean!
  $refreshStream: Boolean
) {
  story(id: $storyID) {
    ...UnansweredCommentsTabContainer_story_206hzj
    id
  }
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  isArchiving
  isArchived
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
  ...ModerationRejectedTombstoneContainer_story
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment CopyCommentEmbedCodeContainer_story on Story {
  url
}

fragment CreateCommentMutation_story on Story {
  id
  url
  viewerRating {
    id
    tags {
      code
    }
    rating
  }
  settings {
    moderation
    mode
    live {
      enabled
    }
    experts {
      id
    }
  }
  ratings {
    count
    average
  }
}

fragment CreateCommentReplyMutation_story on Story {
  url
  settings {
    moderation
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment LocalReplyListContainer_story on Story {
  ...ReplyListCommentContainer_story
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
  ...CopyCommentEmbedCodeContainer_story
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ModerationRejectedTombstoneContainer_story on Story {
  ...CaretContainer_story
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReplyListCommentContainer_comment on Comment {
  id
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListCommentContainer_story on Story {
  ...CommentContainer_story
}

fragment ReplyListContainer1_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer2_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer1_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer2_story
}

fragment ReplyListContainer2_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer3_story
}

fragment ReplyListContainer3_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer4_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer4_story
}

fragment ReplyListContainer4_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer5_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer4_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer5_story
}

fragment ReplyListContainer5_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer6_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer5_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer6_story
}

fragment ReplyListContainer6_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer6_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainerLast_story
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  status
  id
  ...ReplyListContainer_comment_1fYj9E
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies, refreshStream: false) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
}

fragment ReplyListContainerLast_comment_4768Eu on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_story on Story {
  ...LocalReplyListContainer_story @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_story @include(if: $flattenReplies)
}

fragment ReplyListContainer_comment_1fYj9E on Comment {
  id
  status
}

fragment ReplyListContainer_comment_4768Eu on Comment {
  id
  status
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UnansweredCommentsTabCommentContainer_comment_4768Eu on Comment {
  id
  ...CommentContainer_comment
  ...ReplyListContainer1_comment_4768Eu
  ...IgnoredTombstoneOrHideContainer_comment
}

fragment UnansweredCommentsTabCommentContainer_story on Story {
  ...ReplyListContainer1_story
  ...CommentContainer_story
}

fragment UnansweredCommentsTabContainer_story_206hzj on Story {
  id
  isClosed
  settings {
    live {
      enabled
    }
  }
  commentCounts {
    tags {
      UNANSWERED
    }
  }
  comments(first: $count, after: $cursor, orderBy: $orderBy, tag: UNANSWERED, refreshStream: $refreshStream) {
    edges {
      node {
        id
        ...UnansweredCommentsTabCommentContainer_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
  ...UnansweredCommentsTabCommentContainer_story
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    } as any), v4 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refreshStream"
    } as any), v5 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v6 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v7 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
    } as any), v8 = ({
        "kind": "Variable",
        "name": "refreshStream",
        "variableName": "refreshStream"
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v10 = [
        (v9 /*: any*/)
    ], v11 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any),
        (v7 /*: any*/),
        (v8 /*: any*/),
        ({
            "kind": "Literal",
            "name": "tag",
            "value": "UNANSWERED"
        } as any)
    ], v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v9 /*: any*/),
            (v12 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredCommenter",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newCommenter",
                "storageKey": null
            },
            (v13 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v9 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "illegal",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v31 = [
        (v27 /*: any*/),
        (v29 /*: any*/)
    ], v32 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v26 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v28 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v31 /*: any*/),
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v31 /*: any*/),
                        "type": "BlueskyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v28 /*: any*/)
                        ],
                        "type": "TenorMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v10 /*: any*/),
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v27 /*: any*/),
            (v9 /*: any*/)
        ],
        "storageKey": null
    } as any), v35 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v36 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v37 = [
        (v35 /*: any*/),
        (v36 /*: any*/),
        (v8 /*: any*/)
    ], v38 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spamBanned",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v42 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v43 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v44 = ({
        "kind": "ClientExtension",
        "selections": [
            (v39 /*: any*/),
            (v40 /*: any*/),
            (v41 /*: any*/),
            (v42 /*: any*/),
            (v43 /*: any*/)
        ]
    } as any), v45 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v9 /*: any*/),
                (v43 /*: any*/),
                (v41 /*: any*/),
                (v14 /*: any*/),
                (v15 /*: any*/),
                (v16 /*: any*/),
                (v13 /*: any*/),
                (v17 /*: any*/),
                (v18 /*: any*/),
                (v19 /*: any*/),
                (v20 /*: any*/),
                (v40 /*: any*/),
                (v21 /*: any*/),
                (v22 /*: any*/),
                (v23 /*: any*/),
                (v42 /*: any*/),
                (v24 /*: any*/),
                (v25 /*: any*/),
                (v39 /*: any*/),
                (v32 /*: any*/),
                (v33 /*: any*/),
                (v34 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v46 = ({
        "kind": "Literal",
        "name": "refreshStream",
        "value": false
    } as any), v47 = [
        (v35 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v36 /*: any*/),
        (v46 /*: any*/)
    ], v48 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v49 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v50 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v51 = [
        "orderBy",
        "refreshStream"
    ], v52 = ({
        "alias": null,
        "args": (v47 /*: any*/),
        "filters": (v51 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v53 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v45 /*: any*/)
    } as any), v54 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v47 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v50 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v9 /*: any*/),
                                    (v38 /*: any*/),
                                    (v43 /*: any*/),
                                    (v41 /*: any*/),
                                    (v14 /*: any*/),
                                    (v15 /*: any*/),
                                    (v16 /*: any*/),
                                    (v13 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    (v19 /*: any*/),
                                    (v20 /*: any*/),
                                    (v40 /*: any*/),
                                    (v21 /*: any*/),
                                    (v22 /*: any*/),
                                    (v23 /*: any*/),
                                    (v42 /*: any*/),
                                    (v24 /*: any*/),
                                    (v25 /*: any*/),
                                    (v39 /*: any*/),
                                    (v32 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v26 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v26 /*: any*/),
                            (v48 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v49 /*: any*/)
                ],
                "storageKey": null
            },
            (v52 /*: any*/)
        ]
    } as any), v55 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v53 /*: any*/),
                    (v54 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v56 = ({
        "alias": null,
        "args": (v37 /*: any*/),
        "filters": (v51 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v57 = [
        (v35 /*: any*/),
        (v36 /*: any*/),
        (v46 /*: any*/)
    ], v58 = [
        (v55 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        (v38 /*: any*/),
                        (v43 /*: any*/),
                        (v41 /*: any*/),
                        (v14 /*: any*/),
                        (v15 /*: any*/),
                        (v16 /*: any*/),
                        (v13 /*: any*/),
                        (v17 /*: any*/),
                        (v18 /*: any*/),
                        (v19 /*: any*/),
                        (v20 /*: any*/),
                        (v40 /*: any*/),
                        (v21 /*: any*/),
                        (v22 /*: any*/),
                        (v23 /*: any*/),
                        (v42 /*: any*/),
                        (v24 /*: any*/),
                        (v25 /*: any*/),
                        (v39 /*: any*/),
                        (v32 /*: any*/),
                        (v33 /*: any*/),
                        (v34 /*: any*/),
                        (v26 /*: any*/),
                        (v53 /*: any*/),
                        (v54 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v48 /*: any*/)
            ],
            "storageKey": null
        } as any),
        (v49 /*: any*/)
    ], v59 = ({
        "alias": null,
        "args": (v57 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": (v58 /*: any*/),
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v60 = ({
        "alias": null,
        "args": (v57 /*: any*/),
        "filters": (v51 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v61 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v59 /*: any*/),
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v62 = ({
        "alias": null,
        "args": (v57 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v9 /*: any*/),
                            (v38 /*: any*/),
                            (v43 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v42 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v39 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v59 /*: any*/),
                            (v60 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v48 /*: any*/)
                ],
                "storageKey": null
            },
            (v49 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v63 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v62 /*: any*/),
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v64 = ({
        "alias": null,
        "args": (v57 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v63 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v9 /*: any*/),
                            (v38 /*: any*/),
                            (v43 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v42 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v39 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v62 /*: any*/),
                            (v60 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v48 /*: any*/)
                ],
                "storageKey": null
            },
            (v49 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v65 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v64 /*: any*/),
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v66 = ({
        "alias": null,
        "args": (v57 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v65 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v9 /*: any*/),
                            (v38 /*: any*/),
                            (v43 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v42 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v39 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v64 /*: any*/),
                            (v60 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v48 /*: any*/)
                ],
                "storageKey": null
            },
            (v49 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v67 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v66 /*: any*/),
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v68 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v48 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v9 /*: any*/),
                    (v38 /*: any*/),
                    (v43 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v42 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v39 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    {
                        "alias": null,
                        "args": (v57 /*: any*/),
                        "concreteType": "CommentsConnection",
                        "kind": "LinkedField",
                        "name": "replies",
                        "plural": false,
                        "selections": [
                            (v67 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v9 /*: any*/),
                                            (v38 /*: any*/),
                                            (v43 /*: any*/),
                                            (v41 /*: any*/),
                                            (v14 /*: any*/),
                                            (v15 /*: any*/),
                                            (v16 /*: any*/),
                                            (v13 /*: any*/),
                                            (v17 /*: any*/),
                                            (v18 /*: any*/),
                                            (v19 /*: any*/),
                                            (v20 /*: any*/),
                                            (v40 /*: any*/),
                                            (v21 /*: any*/),
                                            (v22 /*: any*/),
                                            (v23 /*: any*/),
                                            (v42 /*: any*/),
                                            (v24 /*: any*/),
                                            (v25 /*: any*/),
                                            (v39 /*: any*/),
                                            (v32 /*: any*/),
                                            (v33 /*: any*/),
                                            (v34 /*: any*/),
                                            (v66 /*: any*/),
                                            (v60 /*: any*/),
                                            (v26 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    (v48 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v49 /*: any*/)
                        ],
                        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
                    },
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                (v7 /*: any*/),
                                (v8 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_story"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v5 /*: any*/),
                (v2 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Operation",
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "enabled",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "UNANSWERED",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v11 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v13 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v37 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v38 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v37 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v9 /*: any*/),
                                                                                                (v38 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v23 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v25 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v33 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v37 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v9 /*: any*/),
                                                                                                                        (v38 /*: any*/),
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v15 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v13 /*: any*/),
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v22 /*: any*/),
                                                                                                                        (v23 /*: any*/),
                                                                                                                        (v24 /*: any*/),
                                                                                                                        (v25 /*: any*/),
                                                                                                                        (v32 /*: any*/),
                                                                                                                        (v33 /*: any*/),
                                                                                                                        (v34 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": (v37 /*: any*/),
                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "replies",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "Comment",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                (v13 /*: any*/),
                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": (v37 /*: any*/),
                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "replies",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": null,
                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "edges",
                                                                                                                                                            "plural": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": null,
                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "node",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        (v9 /*: any*/),
                                                                                                                                                                        (v38 /*: any*/),
                                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                                        (v15 /*: any*/),
                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                        (v13 /*: any*/),
                                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                                        (v24 /*: any*/),
                                                                                                                                                                        (v25 /*: any*/),
                                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                                        (v33 /*: any*/),
                                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": (v37 /*: any*/),
                                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "replies",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": null,
                                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "edges",
                                                                                                                                                                                    "plural": true,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        {
                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                            "args": null,
                                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                            "name": "node",
                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                                (v13 /*: any*/),
                                                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                                (v44 /*: any*/),
                                                                                                                                                                                                {
                                                                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                                                    "passingValue": false,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                                                            "selections": (v45 /*: any*/)
                                                                                                                                                                                                        }
                                                                                                                                                                                                    ]
                                                                                                                                                                                                },
                                                                                                                                                                                                {
                                                                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                                                    "passingValue": true,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                            "args": (v47 /*: any*/),
                                                                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                            "name": "replies",
                                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                                    "args": null,
                                                                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                                    "name": "edges",
                                                                                                                                                                                                                    "plural": true,
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        {
                                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                                            "args": null,
                                                                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                                            "name": "node",
                                                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                                                                (v13 /*: any*/),
                                                                                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                                                                (v44 /*: any*/)
                                                                                                                                                                                                                            ],
                                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                                        },
                                                                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                                                                        (v48 /*: any*/)
                                                                                                                                                                                                                    ],
                                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                                },
                                                                                                                                                                                                                (v49 /*: any*/),
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        (v50 /*: any*/)
                                                                                                                                                                                                                    ]
                                                                                                                                                                                                                }
                                                                                                                                                                                                            ],
                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                        },
                                                                                                                                                                                                        (v52 /*: any*/)
                                                                                                                                                                                                    ]
                                                                                                                                                                                                }
                                                                                                                                                                                            ],
                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                        },
                                                                                                                                                                                        (v48 /*: any*/)
                                                                                                                                                                                    ],
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v49 /*: any*/),
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        (v55 /*: any*/)
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v56 /*: any*/),
                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                        (v44 /*: any*/)
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v48 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v49 /*: any*/),
                                                                                                                                                        {
                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                            "selections": [
                                                                                                                                                                (v61 /*: any*/)
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v56 /*: any*/),
                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                (v44 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v48 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v49 /*: any*/),
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": [
                                                                                                                                        (v63 /*: any*/)
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v56 /*: any*/),
                                                                                                                        (v26 /*: any*/),
                                                                                                                        (v44 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v48 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v49 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v65 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v56 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v44 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v48 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v49 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v67 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v56 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v44 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v48 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v49 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v68 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v56 /*: any*/),
                                                (v26 /*: any*/),
                                                (v44 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v48 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v49 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v48 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        (v43 /*: any*/),
                                                        (v41 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v40 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v42 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v39 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v37 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v68 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v9 /*: any*/),
                                                                                (v38 /*: any*/),
                                                                                (v43 /*: any*/),
                                                                                (v41 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                (v40 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v42 /*: any*/),
                                                                                (v24 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                (v39 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": (v37 /*: any*/),
                                                                                    "concreteType": "CommentsConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "replies",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v67 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "CommentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Comment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v9 /*: any*/),
                                                                                                        (v38 /*: any*/),
                                                                                                        (v43 /*: any*/),
                                                                                                        (v41 /*: any*/),
                                                                                                        (v14 /*: any*/),
                                                                                                        (v15 /*: any*/),
                                                                                                        (v16 /*: any*/),
                                                                                                        (v13 /*: any*/),
                                                                                                        (v17 /*: any*/),
                                                                                                        (v18 /*: any*/),
                                                                                                        (v19 /*: any*/),
                                                                                                        (v20 /*: any*/),
                                                                                                        (v40 /*: any*/),
                                                                                                        (v21 /*: any*/),
                                                                                                        (v22 /*: any*/),
                                                                                                        (v23 /*: any*/),
                                                                                                        (v42 /*: any*/),
                                                                                                        (v24 /*: any*/),
                                                                                                        (v25 /*: any*/),
                                                                                                        (v39 /*: any*/),
                                                                                                        (v32 /*: any*/),
                                                                                                        (v33 /*: any*/),
                                                                                                        (v34 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": (v37 /*: any*/),
                                                                                                            "concreteType": "CommentsConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "replies",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v65 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "Comment",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                (v9 /*: any*/),
                                                                                                                                (v38 /*: any*/),
                                                                                                                                (v43 /*: any*/),
                                                                                                                                (v41 /*: any*/),
                                                                                                                                (v14 /*: any*/),
                                                                                                                                (v15 /*: any*/),
                                                                                                                                (v16 /*: any*/),
                                                                                                                                (v13 /*: any*/),
                                                                                                                                (v17 /*: any*/),
                                                                                                                                (v18 /*: any*/),
                                                                                                                                (v19 /*: any*/),
                                                                                                                                (v20 /*: any*/),
                                                                                                                                (v40 /*: any*/),
                                                                                                                                (v21 /*: any*/),
                                                                                                                                (v22 /*: any*/),
                                                                                                                                (v23 /*: any*/),
                                                                                                                                (v42 /*: any*/),
                                                                                                                                (v24 /*: any*/),
                                                                                                                                (v25 /*: any*/),
                                                                                                                                (v39 /*: any*/),
                                                                                                                                (v32 /*: any*/),
                                                                                                                                (v33 /*: any*/),
                                                                                                                                (v34 /*: any*/),
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": (v37 /*: any*/),
                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "replies",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        (v63 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        (v9 /*: any*/),
                                                                                                                                                        (v38 /*: any*/),
                                                                                                                                                        (v43 /*: any*/),
                                                                                                                                                        (v41 /*: any*/),
                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                        (v15 /*: any*/),
                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                        (v13 /*: any*/),
                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                        (v40 /*: any*/),
                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                        (v42 /*: any*/),
                                                                                                                                                        (v24 /*: any*/),
                                                                                                                                                        (v25 /*: any*/),
                                                                                                                                                        (v39 /*: any*/),
                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                        (v33 /*: any*/),
                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": (v37 /*: any*/),
                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "replies",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                (v61 /*: any*/),
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": null,
                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "edges",
                                                                                                                                                                    "plural": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": null,
                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "node",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                (v43 /*: any*/),
                                                                                                                                                                                (v41 /*: any*/),
                                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                (v13 /*: any*/),
                                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                                (v40 /*: any*/),
                                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                                (v42 /*: any*/),
                                                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                                                (v39 /*: any*/),
                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": (v37 /*: any*/),
                                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "replies",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": (v58 /*: any*/),
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v56 /*: any*/),
                                                                                                                                                                                (v26 /*: any*/)
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v48 /*: any*/)
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v49 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v56 /*: any*/),
                                                                                                                                                        (v26 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v48 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v49 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v56 /*: any*/),
                                                                                                                                (v26 /*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v48 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v49 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v56 /*: any*/),
                                                                                                        (v26 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v48 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v49 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v56 /*: any*/),
                                                                                (v26 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v48 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v49 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v56 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v11 /*: any*/),
                            "filters": [
                                "orderBy",
                                "tag",
                                "refreshStream"
                            ],
                            "handle": "connection",
                            "key": "UnansweredStream_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        (v27 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                (v20 /*: any*/),
                                (v18 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryRatings",
                            "kind": "LinkedField",
                            "name": "ratings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "average",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "3fa1cea298c68bd146236a2efb689269",
            "metadata": {},
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '0b00bca1113fc2245536cc231ec062e3';
export default node;
